/**
 * Y21 frontdoor: the October youth outreach push on the homepage.
 *
 * Gated on one flag, on both halves of the feature: the homepage slot only
 * renders the two Y21 animations (the Daily Drop Room and Bring a Friend)
 * while it is on, and the preview route bounces to /tabs/home while it is off. The flag row is created OFF in
 * production (see docs/y21-frontdoor.md).
 */
export const Y21_FLAG = 'y21-frontdoor';

// Test-only overrides for the homepage slot while there is no CMS entry yet:
// with the main flag on, each of these puts one Y21 animation in the slot
// ahead of whatever the CMS says. Target them at the testers' usernames in
// development; neither should exist in production.
export const Y21_SLOT_ROOM_FLAG = 'y21-home-slot-room';
export const Y21_SLOT_FRIEND_FLAG = 'y21-home-slot-friend';

// The event the room's copy names.
export const Y21_EVENT = {
  name: 'Y21',
};
